/**
 * Mock store for integration testing purposes.  Implements reducers for the actions which can be dispatched in isolation (outside of the web app itself).
 */
import { configureStore } from "@reduxjs/toolkit";
import { storylineReducer } from "./storyline";
import { notificationsReducer } from "./notifications";
import { profilingReducer } from "../../src/store/profiling/reducers";
import { tracingReducer } from "../../src/store/tracing/reducers";

export type StubStoreState = {
    parameterValues?: Record<string, any>;
    canvasState?: Record<string, any>;
    frameData?: Record<string, any>;
    templates?: Record<string, { jsx: string, css?: string }>;
}

export const initializeStubStore = (initialState: StubStoreState) => configureStore({
    reducer: {
        storyline: storylineReducer,
        notifications: notificationsReducer,
        // Canvas / Template call useProfilingSink, which reads s.profiling; the reducer's own
        // initialState (profiling disabled) is sufficient for tests.
        profiling: profilingReducer,
        // storyline thunks dispatch addTraceEvent, which reads s.tracing.enabled (disabled by default).
        tracing: tracingReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
    preloadedState: {
        notifications: {
            notifications: [],
            outstandingRequestCount: 0,
        },
        storyline: {
            parameterValues: new Map(Object.entries(initialState.parameterValues ?? {})),
            canvasState: initialState.canvasState ?? {},
            currentParagraph: {
                data: initialState.frameData ?? {},
            },
            datasources: new Map<string, any>(),
            storyline: {
                templates: initialState.templates ?? {},
            },
        },
    },
});